import { Service } from '@/services/api';
import { ClientAccount, ClientView, ClientViewAccount } from '@/types/ClientView';

class ClientViewService extends Service {
  async getClientViews(): Promise<ClientView[]> {
    return this.get<ClientView[]>('/v2/client-views').then(this.handleResponse);
  }

  async createClientView(clientView: Partial<ClientView>): Promise<ClientView> {
    return this.post<ClientView>('/v2/client-views', clientView).then(this.handleResponse);
  }

  async deleteClientView(id: number): Promise<void> {
    return this.delete<void>(`/v2/client-views/${id}`).then(this.handleResponse);
  }

  async getClientAccountsByIds(accountIds: number[]): Promise<ClientAccount[]> {
    return this.get<ClientAccount[]>('/v2/client-accounts', {accountId: accountIds}).then(this.handleResponse);
  }

  async getClientViewAccounts(): Promise<ClientViewAccount[]> {
    return this.get<ClientViewAccount[]>('/v2/client-view-accounts').then(this.handleResponse);
  }
}

export const clientViewService = new ClientViewService();
